import { parsePhoneNumberFromString } from 'libphonenumber-js';

/** Falls back to the raw input when the number can't be parsed, so bad legacy data doesn't disappear. */
export function formatPhoneNumber(number: string | null | undefined): string {
  if (!number) return '';
  const parsed = parsePhoneNumberFromString(number, 'NG');
  return parsed ? parsed.formatInternational() : number;
}

export function phoneDigits(number: string | null | undefined): string {
  if (!number) return '';
  const parsed = parsePhoneNumberFromString(number, 'NG');
  return parsed ? parsed.number.replace(/\D/g, '') : number.replace(/\D/g, '');
}
